import React, { Component } from 'react';
import { Alert, Label } from 'reactstrap';
import numberToWords from 'number-to-words';
import { FieldArray } from 'formik';
import AddButton from '~/components/addButton/addButton';
import FormikInputField from '~/components/formikInputField/formikInputField';
import FormLayout from '~/components/formLayout/formLayout';
import IconTooltip from '~/components/iconTooltip/iconTooltip';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import BriteTankDropdown from '~/containers/briteTankDropdown/briteTankDropdown';
import UniTankDropdown from '~/containers/uniTankDropdown/uniTankDropdown';
import ConsolidatedLotScheduleDropdown from '~/containers/consolidatedLotScheduleDropdown/consolidatedLotScheduleDropdown';
import LocationDropdown from '~/containers/locationDropdown/locationDropdown';
import { renderError, hasError } from '~/utils/formikValidation';
import NoAddNewTransferModal from './noAddNewTransferModal';
import styles from './styles.css';

const newStep = {
  name: '',
  type: 'TANK',
  tankType: 'BRITE_TANK',
  isConsolidated: false,
  requiresDutyPaid: false
};

export class TransferScheduleForm extends Component {
  state = {
    noNewStepModalVisibe: false
  };

  onCloseModal = () => {
    this.setState({ noNewStepModalVisibe: false });
  };

  onAddStepClick = arrayHelpers => {
    const { transfers } = this.props.values;

    try {
      const lastTransfer = transfers[transfers.length - 1];
      if (lastTransfer.tankType === 'UNI_TANK') {
        this.setState({
          noNewStepModalVisibe: true
        });
        return;
      } else {
      }
    } catch (err) {
      console.error('Error adding new transfer step', err);
    }
    arrayHelpers.push(newStep);
  };

  render() {
    const { values, errors, handleSubmit, isSubmitting } = this.props;
    const { transfers, isConsolidated } = values;
    return (
      <form onSubmit={handleSubmit}>
        {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
        <FormLayout title="Transfer schedule overview">
          <div className="mb3">
            <Label>Name</Label>
            <FormikInputField name="name" invalid={!!errors.name} />
            {errors.name && (
              <p data-qa="name-error" className="error">
                {errors.name}
              </p>
            )}
          </div>
          <div className="mb3">
            <Label>Description</Label>
            <FormikInputField type="textarea" name="description" />
          </div>
          <div className="mb3 ml4">
            <FormikInputField type="checkbox" checked={isConsolidated} name="isConsolidated" />
            <Label>Only use this schedule for consolidated lots</Label>
          </div>
        </FormLayout>
        <FormLayout className="mt4" title="Individual transfers">
          <FieldArray
            name="transfers"
            validateOnChange={false}
            render={arrayHelpers => (
              <div>
                {transfers.map((transfer, idx) => (
                  <div key={idx} className={styles.step}>
                    <div className="flex justify-between">
                      <h5 className="f6 mr3 ttu flex-grow-1">Step {numberToWords.toWords(idx + 1)}</h5>
                      {transfers.length > 1 && (
                        <div className="flex">
                          {idx !== 0 && (
                            <IconTooltip
                              icon="chevron-left"
                              text="Move step up"
                              className="ml3 rotate-90"
                              onClick={() => arrayHelpers.move(idx, idx - 1)}
                            />
                          )}
                          {idx !== transfers.length - 1 && (
                            <IconTooltip
                              icon="chevron-left"
                              text="Move step down"
                              className="ml3 rotate-270"
                              onClick={() => arrayHelpers.move(idx, idx + 1)}
                            />
                          )}
                          <IconTooltip
                            icon="delete-circle"
                            text="Remove step"
                            className="ml3 stroke-brand-red"
                            onClick={() => arrayHelpers.remove(idx)}
                          />
                        </div>
                      )}
                    </div>
                    <div className="mh3">
                      <div className="mb3">
                        <Label>Name</Label>
                        <FormikInputField
                          name={`transfers.${idx}.name`}
                          invalid={hasError(errors, idx, 'transfers', 'name')}
                        />
                        {renderError(errors, idx, 'transfers', 'name')}
                      </div>
                      <div className="mb3">
                        <Label>What is this step involve?</Label>
                        <FormikInputField type="select" name={`transfers.${idx}.type`}>
                          <option value="TANK">To another tank</option>
                          <option value="VESSEL">Final delivery vessels</option>
                          <option value="LOCATION">A location within the brewery</option>
                          <option value="DRY_HOP">Dry hopping</option>
                          <option value="CLARIFICATION">Clarification</option>
                        </FormikInputField>
                      </div>
                      {transfers[idx].type === 'LOCATION' && (
                        <div className="mb3">
                          <Label>What location?</Label>
                          <LocationDropdown name={`transfers.${idx}.locationId`} />
                        </div>
                      )}
                      {transfers[idx].type === 'TANK' && (
                        <div className="flex mb3">
                          <div className="flex-grow-1">
                            <Label>What sort of tank?</Label>
                            <FormikInputField
                              type="select"
                              name={`transfers.${idx}.tankType`}
                              invalid={hasError(errors, idx, 'transfers', 'tankType')}
                            >
                              <option value="BREW_KEG">A brew keg</option>
                              <option value="BREW_TANK">A brew tank</option>
                              <option value="BRITE_TANK">A brite tank</option>
                              <option value="UNI_TANK">A uni tank</option>
                            </FormikInputField>
                            {renderError(errors, idx, 'transfers', 'tankType')}
                          </div>
                          {transfers[idx].tankType === 'BRITE_TANK' && (
                            <div className="ml3 flex-grow-1">
                              <Label>What brite tank?</Label>
                              <BriteTankDropdown name={`transfers.${idx}.tankId`} />
                              {renderError(errors, idx, 'transfers', 'tankId')}
                            </div>
                          )}
                          {transfers[idx].tankType === 'UNI_TANK' && (
                            <div className="ml3 flex-grow-1">
                              <Label>What uni tank?</Label>
                              <UniTankDropdown name={`transfers.${idx}.tankId`} />
                              {renderError(errors, idx, 'transfers', 'tankId')}
                            </div>
                          )}
                        </div>
                      )}
                      {transfers[idx].type === 'VESSEL' && (
                        <div className="mb3">
                          <Label>Vessel description</Label>
                          <FormikInputField
                            name={`transfers.${idx}.vesselDescription`}
                            placeholder="e.g. Kegs and/or bottles"
                            invalid={hasError(errors, idx, 'transfers', 'vesselDescription')}
                          />
                          {renderError(errors, idx, 'transfers', 'vesselDescription')}
                        </div>
                      )}
                      <div className="mb3">
                        <Label>How long until this transfer (in days)?</Label>
                        <FormikInputField
                          name={`transfers.${idx}.days`}
                          invalid={hasError(errors, idx, 'transfers', 'days')}
                        />
                        {renderError(errors, idx, 'transfers', 'days')}
                      </div>
                      <div className="mb3 ml4">
                        <div>
                          <FormikInputField
                            type="checkbox"
                            checked={transfers[idx].requiresDutyPaid}
                            name={`transfers.${idx}.requiresDutyPaid`}
                          />
                          <Label>The lot needs to have duty paid before completing this step</Label>
                        </div>
                        <div>
                          <FormikInputField
                            type="checkbox"
                            checked={transfers[idx].shouldAutocomplete}
                            name={`transfers.${idx}.shouldAutocomplete`}
                          />
                          <Label>This step should be automatically completed the day it's due</Label>
                        </div>
                      </div>
                      {transfers[idx].shouldAutocomplete &&
                        transfers[idx].type === 'TANK' &&
                        transfers[idx].tankType === 'UNI_TANK' && (
                          <div className="mb3">
                            <Label>What consolidated lot schedule would you like to follow from this?</Label>
                            <ConsolidatedLotScheduleDropdown name={`transfers.${idx}.nextTransferScheduleId`} />
                            {renderError(errors, idx, 'transfers', 'nextTransferScheduleId')}
                          </div>
                        )}
                      <div className="mb3">
                        <Label>Notes</Label>
                        <FormikInputField type="textarea" name={`transfers.${idx}.notes`} />
                      </div>
                    </div>
                  </div>
                ))}
                <div className="tr">
                  <AddButton color="primary" onClick={() => this.onAddStepClick(arrayHelpers)}>
                    Add another step
                  </AddButton>
                </div>
              </div>
            )}
          />
        </FormLayout>
        <NoAddNewTransferModal toggle={this.onCloseModal} isOpen={this.state.noNewStepModalVisibe} />
        <div className="flex justify-end mt4">
          <SubmissionButton color="primary" type="submit" isSubmitting={isSubmitting}>
            Save
          </SubmissionButton>
        </div>
      </form>
    );
  }
}

const TransferScheduleFormWrapper = props => <TransferScheduleForm {...props} />;
export default TransferScheduleFormWrapper;



// WEBPACK FOOTER //
// ./src/components/transferScheduleForm/transferScheduleForm.jsx